import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Button/Button";
import { Field } from "formik";
import FormInput2 from "../../components/FormInput/FormInput2";

export const SignUpForm1 = (props) => {
  const [checked, setChecked] = useState(false);
  const { page2, handleClick, hide, block } = props;

  return (
    <div className="form-1">
      <div className="form-input">
        <Field
          name="email"
          label="Email Address"
          placeholder="Enter email address"
          component={FormInput2}
        />
      </div>
      <div className="form-input-password">
        <span id="show" onClick={handleClick}>
          {hide ? "SHOW" : "HIDE"}
        </span>
        <Field
          name="password"
          label="Password"
          placeholder="Enter Password"
          type={hide ? "password" : "text"}
          component={FormInput2}
        />
      </div>

      <div className="form-input-button">
        <Button
          width="100%"
          height="45px"
          word={"CONTINUE"}
          disabled={block || !checked}
          onClick={page2}
        />
      </div>

      <div id="terms">
        <input
          className="terms-check-button"
          type="checkbox"
          onChange={() => setChecked(!checked)}
        />
        <p className="agree">
          By clicking the "CONTINUE" button, you are creating a NIBSS account,
          and you agree to NIBSS's{" "}
          <Link
            to={{
              pathname: "/terms-and-conditions",
            }}
            style={{
              color: "#22a4ef",
              textDecoration: "none",
            }}
          >
            Terms of Use{" "}
          </Link>
          and{" "}
          <Link
            to={{
              pathname: "/",
            }}
            style={{
              color: "#22a4ef",
              textDecoration: "none",
            }}
          >
            Privacy Policy
          </Link>
          .
        </p>
      </div>

      <div className="form-bottom-signin">
        <p>
          Sign In{" "}
          <Link
            to="/login"
            style={{
              color: "#22a4ef",
              textDecoration: "none",
            }}
          >
            here,
          </Link>{" "}
          if you already have an account
        </p>
      </div>
    </div>
  );
}

SignUpForm1.propTypes = {
  block: PropTypes.any,
  handleClick: PropTypes.any,
  hide: PropTypes.any,
  page2: PropTypes.any
}

export default SignUpForm1;
